"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconsReact = require("../../../../icons-react");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var EmptyTicketsList = function EmptyTicketsList() {
  return /*#__PURE__*/_react["default"].createElement(StyledEmptyTicketsListWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledEmptyBox, null), /*#__PURE__*/_react["default"].createElement("span", null, "\u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0438\u043A\u0435\u0442\u043E\u0432 \u043F\u0443\u0441\u0442. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u0438"));
};
var StyledEmptyTicketsListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "EmptyTicketsList__StyledEmptyTicketsListWrapper",
  componentId: "sc-1hkbr3j-0"
})(["background:transparent;border-radius:4px;border:2px dashed #c0c2c4;height:160px;width:280px;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#4d4d4d;span{font-size:16px;text-align:center;margin-top:5px;}"]);
var StyledEmptyBox = (0, _styledComponents["default"])(_iconsReact.EmptyBox).withConfig({
  displayName: "EmptyTicketsList__StyledEmptyBox",
  componentId: "sc-1hkbr3j-1"
})(["fill:#4d4d4d;width:70px;"]);
var _default = exports["default"] = EmptyTicketsList;